export const iconFontAwesomeUsersPeopleUsersViewfinder = (
	<i className="fa-solid fa-users-viewfinder"></i>
);
